
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep, sumBy, isNil, find } from 'lodash';
import { formatDateToDisplay } from '@/helpers';
import { ActivityKeyMapDTO, HRMUserEngagementTimeSheetDTO, TableHeaderColumns } from '@/models';
import UserInformation from '@/components/common/user-information/UserInformation.vue';

@Component({
  components: {
    UserInformation
  }
})
export default class HrmDataTable extends Vue {
  @Prop({ default: () => [] }) hrmMemberTimeSheets: HRMUserEngagementTimeSheetDTO[];
  @Prop() userId: number;
  @Prop({ default: true }) isEditMode: boolean;
  @Prop({
    default: () => {
      return true;
    }
  })
  activityKeyMap: ActivityKeyMapDTO;

  totalHours = 0;

  hrmDataByUserId: HRMUserEngagementTimeSheetDTO[] = [];
  hrmMemberTimeSheetsSelected: HRMUserEngagementTimeSheetDTO[] = [];
  expandItem = [] as HRMUserEngagementTimeSheetDTO[];

  @Watch('hrmMemberTimeSheetsSelected', { deep: true })
  onHrmMemberTimeSheetsSelectedChanged(hrmMemberTimeSheetsSelected: HRMUserEngagementTimeSheetDTO[]): void {
    const filterHrmMemberTimeSheets = hrmMemberTimeSheetsSelected
      .filter(({ isApproved }) => isApproved)
      .map(item => ({
        ...item,
        totalHourTask: Number(item.totalHourTask)
      }));
    this.totalHours = sumBy(filterHrmMemberTimeSheets, 'totalHourTask');
    this.$emit('change', this.totalHours, hrmMemberTimeSheetsSelected);
  }

  mounted(): void {
    this.totalHours = sumBy(this.hrmDataByUserId, 'totalHourTask');
  }

  onRowClick(item: HRMUserEngagementTimeSheetDTO): void {
    const existItem = find(this.expandItem, item);
    if (existItem) {
      this.expandItem = [];
      return;
    }
    if (!this.isEditMode && !item.note) {
      this.expandItem = [];
      return;
    }
    this.expandItem = [item];
  }

  getLabelNote(note: string): string {
    if (!this.isEditMode && !note) {
      return 'Empty Note';
    }
    return note ? note : 'Add Note';
  }

  isEditedTotalHourTask(item: HRMUserEngagementTimeSheetDTO): boolean {
    if (this.isEditMode) {
      return false;
    }
    if (!item?.totalHourTaskOriginal) {
      return false;
    }

    return item?.totalHourTask !== item?.totalHourTaskOriginal;
  }

  get headers(): TableHeaderColumns {
    const headers = [
      {
        value: 'periodEndDate',
        text: 'Date',
        width: '18%'
      },
      {
        value: 'activityName',
        text: 'Activity Name'
      },
      {
        value: 'task',
        text: 'Task'
      },
      {
        value: 'totalHourTask',
        text: 'Total Hour',
        align: 'end',
        width: '15%'
      },
      {
        value: 'isApproved',
        text: 'Approve Status',
        cellClass: 'd-flex align-center pl-10'
      },
      {
        value: 'note',
        text: 'Note',
        cellClass: 'text-truncate note-max-width'
      }
    ];

    if (Object.keys(this.activityKeyMap || {}).length > 0) {
      headers.splice(3, 0, {
        text: 'Pollens',
        value: 'key',
        width: '5%'
      });
    }
    return headers;
  }

  getDateByItem(periodEndDate: string): string {
    return formatDateToDisplay(periodEndDate);
  }

  @Watch('userId', { immediate: true })
  onUserIdChanged(): void {
    const cloneHrmMemberTimeSheets = cloneDeep(this.hrmMemberTimeSheets);
    if (this.userId && cloneHrmMemberTimeSheets) {
      this.hrmDataByUserId = cloneHrmMemberTimeSheets
        .filter(({ user }) => user.id === this.userId)
        .map((hrmData, index) => {
          return { id: index, ...hrmData, isApproved: isNil(hrmData?.isApproved) ? true : hrmData?.isApproved };
        });
      if (this.isEditMode) {
        this.hrmMemberTimeSheetsSelected = this.hrmDataByUserId;
      }
    }
  }
}
